module.exports = __webpack_public_path__ + "static/media/alert-triangle.f34ed914.svg";